import TagsList from './tagsList.js';
export default TagsList;
